import { render, staticRenderFns } from "./TestUserCreated.vue?vue&type=template&id=57498658&"
import script from "./TestUserCreated.vue?vue&type=script&lang=ts&"
export * from "./TestUserCreated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TestUserCreated.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports